import { useAppSelector } from 'common/hooks/redux'
import useGetContentQuery from 'features/unifiedFlow/api/queries/useGetContentQuery'

const useContent = () => {
  const activeContentId = useAppSelector(
    (state) => state.unifiedFlow.activeContentId
  )

  const contentQuery = useGetContentQuery(activeContentId)

  return {
    content: contentQuery.data,
    refetch: contentQuery.refetch,
    isLoading: contentQuery.isFetching,
  }
}

export default useContent
